import { render } from "./Points.vue?vue&type=template&id=074419f4"
import script from "./Points.vue?vue&type=script&lang=js"
export * from "./Points.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__file',"src/vue/views/Points.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "074419f4"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('074419f4', __exports__)) {
    api.reload('074419f4', __exports__)
  }
  
  module.hot.accept("./Points.vue?vue&type=template&id=074419f4", () => {
    api.rerender('074419f4', render)
  })

}


export default __exports__